export const REGISTER_EVENT_BOOKING_START = 'REGISTER_EVENT_BOOKING_START';

export const REGISTER_EVENT_BOOKING_SUCCESS = 'REGISTER_EVENT_BOOKING_SUCCESS';

export const REGISTER_EVENT_BOOKING_FAILED = 'REGISTER_EVENT_BOOKING_FAILED';
